<!-- 'invalid':isUser$()&&!(validStep$ | async)&&isVisitedStep$(), -->
<div class="warp-tooltip">
    <div class="step"
        [ngClass]="{'current':isCurrent,'isPreview':isPreview,'isUser':isUser$(),'inData':isData,'not-bold':isVisitedStep$() || isCurrent}"
        #trigger>
        <div class="right">
            <span>{{index+1}}</span>
            <span *ngIf="stepName!=''&& stepName!=undefined">{{stepName}}</span>
            <span *ngIf="!(stepName!=''&& stepName!=undefined)">אין שם</span>
        </div>
        <svg-icon *ngIf="!isPreview" svgClass=" img" src="/assets/images/steps/dropdown.svg"
            (click)="openMenu()"></svg-icon>
        <div *ngIf="isUser$()" class="indicator">
            <ng-container *ngIf="(isVisitedStep$() || isShowError$())">
                <svg-icon *ngIf="(statusValidStep$ | async)==eStatusValidation.Error" svgClass="img"
                    src="/assets/images/steps/mark-bad.svg"></svg-icon>
                <svg-icon *ngIf="(statusValidStep$ | async)==eStatusValidation.Valid" svgClass="img"
                    src="/assets/images/steps/mark-good.svg"></svg-icon>
                <svg-icon *ngIf="(statusValidStep$ | async)==eStatusValidation.InComplete" svgClass="img"
                    src="/assets/images/steps/mark-incomplete.svg"></svg-icon>
            </ng-container>
        </div>

    </div>
    <div class="tooltip-abs" *ngIf="stepName">
        <p>{{stepName}}</p>
    </div>
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="isMenuStepOpen=false" [cdkConnectedOverlayOpen]="isMenuStepOpen"
    cdkConnectedOverlayBackdropClass="backdrop-selection" [cdkConnectedOverlayPositions]="positonArea">
    <que-step-actions (closeMenuStepEvent)="closeMenu()" [stepName]="stepName" [index]="index"></que-step-actions>
</ng-template>